import { render, staticRenderFns } from "./RegisterDetails.vue?vue&type=template&id=55bc99e4&scoped=true"
import script from "./RegisterDetails.vue?vue&type=script&lang=js"
export * from "./RegisterDetails.vue?vue&type=script&lang=js"
import style0 from "./RegisterDetails.vue?vue&type=style&index=0&id=55bc99e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bc99e4",
  null
  
)

export default component.exports